import { BrandButton } from "../ui/BrandButton";
import { MdEdit } from "react-icons/md";

function formatDateOnly(value) {
  if (!value) {
    return "—";
  }

  return new Intl.DateTimeFormat("es-UY", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(value));
}

function formatValue(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  return value;
}

function getStatusBadgeClass(isDisabled) {
  if (isDisabled) {
    return "bg-rose-100 text-rose-700";
  }

  return "bg-brand-gold-soft text-brand-primary";
}

export function AdminUsersList({
  users,
  pagination,
  currentUserId,
  onEditClick,
  onToggleStatusClick,
  onPrevious,
  onNext,
  emptyText = "No hay usuarios para mostrar.",
}) {
  const hasUsers = users.length > 0;
  const canGoBack = pagination.page > 1;
  const canGoNext = pagination.totalPages > 0 && pagination.page < pagination.totalPages;

  if (!hasUsers) {
    return (
      <div className="rounded-[2rem] border border-brand-secondary/15 bg-white px-6 py-10 text-center text-sm text-slate-500">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      <div className="overflow-hidden rounded-[2rem] border border-brand-secondary/15 bg-white shadow-sm">
        <div className="overflow-x-auto">
          <table className="min-w-[1120px] w-full border-collapse">
            <thead className="sticky top-0 z-10 bg-brand-surface/95 text-left">
              <tr className="border-b border-brand-secondary/15">
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Nombre
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Apellido
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Usuario
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Email
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Celular
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Nacimiento
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Ciudad
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Escuela
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  TNUA
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Padre
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Estado
                </th>
                <th className="px-4 py-4 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-brand-primary">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {users.map((currentUser) => {
                const isDisabled = Boolean(currentUser.disabledAt);
                const isCurrentUser = currentUserId === currentUser.id;

                return (
                  <tr
                    key={currentUser.id}
                    className={[
                      "border-b border-brand-secondary/10 transition-colors last:border-b-0",
                      isDisabled ? "bg-rose-50/60" : "bg-white hover:bg-brand-surface/50",
                    ].join(" ")}
                  >
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.name)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.lastName)}</td>
                    <td className="px-4 py-4 text-sm font-semibold text-slate-900">
                      {currentUser.username ? `@${currentUser.username}` : "—"}
                    </td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.email)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.cellphone)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatDateOnly(currentUser.birthDate)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.cityOfOrigin)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.institution?.name)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">{formatValue(currentUser.tnua?.name)}</td>
                    <td className="px-4 py-4 text-sm text-slate-700">
                      {currentUser.parentName || currentUser.parentLastName
                        ? [currentUser.parentName, currentUser.parentLastName]
                            .filter(Boolean)
                            .join(" ")
                        : "—"}
                    </td>
                    <td className="px-4 py-4">
                      <span
                        className={`rounded-full px-3 py-1 text-xs font-semibold ${getStatusBadgeClass(isDisabled)}`}
                      >
                        {isDisabled ? "Deshabilitado" : "Activo"}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <div className="flex flex-nowrap items-center gap-2">
                        {onEditClick && !isCurrentUser ? (
                          <BrandButton
                            type="button"
                            onClick={() => onEditClick(currentUser)}
                            variant="icon"
                            radius="2xl"
                            size="icon"
                            motion="subtle"
                            className="h-10 w-10 shrink-0"
                            aria-label={`Editar ${currentUser.name} ${currentUser.lastName}`}
                          >
                            <MdEdit className="text-lg" />
                          </BrandButton>
                        ) : null}
                        {onToggleStatusClick && !isCurrentUser ? (
                          <BrandButton
                            type="button"
                            onClick={() => onToggleStatusClick(currentUser)}
                            variant={isDisabled ? "primary" : "secondary"}
                            radius="2xl"
                            size="sm"
                            motion="subtle"
                            className="shrink-0"
                          >
                            {isDisabled ? "Habilitar" : "Deshabilitar"}
                          </BrandButton>
                        ) : null}
                        {isCurrentUser ? (
                          <span className="rounded-full bg-slate-100 px-3 py-2 text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">
                            Tu sesión
                          </span>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex flex-col gap-3 rounded-[2rem] border border-brand-secondary/15 bg-brand-surface px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-slate-600">
          Mostrando {users.length} de {pagination.total} usuarios · Página {pagination.page} de{" "}
          {pagination.totalPages || 1}
        </p>
        <div className="flex items-center gap-2">
          <BrandButton
            type="button"
            onClick={onPrevious}
            disabled={!canGoBack}
            variant="outline"
            radius="2xl"
            size="md"
            motion="subtle"
          >
            Anterior
          </BrandButton>
          <BrandButton
            type="button"
            onClick={onNext}
            disabled={!canGoNext}
            variant="outline"
            radius="2xl"
            size="md"
            motion="subtle"
          >
            Siguiente
          </BrandButton>
        </div>
      </div>
    </div>
  );
}
